/**
 * @file Shared React component — components/Shared/ProtectedRoute.tsx.
 */

import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { JSX } from "react";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { user } = useAuth();
  if (!user) {
    const loginSource = localStorage.getItem("loginSource");
    const redirectPath =
      loginSource === "expert"
        ? "/expert/login"
        : loginSource === "admin"
        ? "/admin/login"
        : "/login";
    return <Navigate to={redirectPath} replace />;
  }
  return children;
};

/** React component — Protected Route. */
export default ProtectedRoute;
